'use client';

import { useState } from 'react';
import { fetchStagingScoops } from '../utils/api';

export default function Home() {
  const [scoops] = useState<{ title: string; fake: boolean }[]>([
    { title: "SPIDER-MAN MENACE STRIKES AGAIN!", fake: true },
    { title: "OSCORP STOCK PLUMMETS", fake: false },
    { title: "WHO IS THE MASKED VIGILANTE?", fake: true },
  ]);

  return (
    <main className="min-h-screen bg-gray-100 text-gray-900 p-8 font-sans">
      {/* TODO: Remove placeholder layout for J.Johan - SPIDEY{f4k3_fl4g_p1ctur3s_0f_sp1d3rm4n} */}
      <header className="border-b-4 border-red-700 pb-4 mb-8">
        <h1 className="text-6xl font-black uppercase text-red-700 tracking-tighter">
          THE DAILY BUGLE
        </h1>
        <p className="text-xl font-bold uppercase text-gray-500 tracking-widest mt-1">
          &quot;He doesn&apos;t want to be famous? Then I&apos;ll make him infamous!&quot;
        </p>
      </header>

      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {scoops.map((scoop, i) => (
          <article key={i} className="bg-white p-6 shadow-md border border-gray-200">
            <span className="text-xs font-bold text-red-600 uppercase mb-2 block">
              {scoop.fake ? "Editorial" : "News"}
            </span>
            <h2 className="text-3xl font-bold uppercase leading-tight mb-4">{scoop.title}</h2>
            <p className="text-gray-700 text-sm">
              Read the full story to find out why J. Jonah Jameson says the truth matters.
            </p>
          </article>
        ))}
      </section>

      {/* 
        DEVELOPER NOTE:
        Feature toggled off in UI. We will re-enable once staging auth is fixed.
      */}
      <button 
        className="hidden"
        onClick={async () => {
             // We still bundle this code, but it's hidden from normal users.
             const hiddenScoops = await fetchStagingScoops();
             console.log(hiddenScoops);
        }}>
        Load Staged Scoops
      </button>

      <footer className="mt-16 text-center text-xs text-gray-400">
        &copy; 1962 The Daily Bugle. All rights reserved.
      </footer>
    </main>
  );
}
